import CryptoJS from 'crypto-js';
import Pagination from './../../../shared/components/pagination';
import CustomExpandableTable from '../../../shared/components/customExpandableTable';
import Loader from '../../../shared/components/loader';
import TripServices from './../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import CONSTANT from './../../../shared/constants/constant'
import FTCMemoDepositSlip from '../FtcRadShipment/FTCMemoDepositSlip';
import Printd from 'printd'
import moment from 'moment';
import Multiselect from 'vue-multiselect'
import JSZip from 'jszip';
import MasterService from '../../../masterdata/services/masterdata.service'
import VueElementLoading from 'vue-element-loading';
import XLSX from 'xlsx';

export default {
  name: 'FTCPaidCashMemo',
  components: {
    CryptoJS,
    Pagination,
    CustomExpandableTable,
    Loader,
    TripServices,
    FTCMemoDepositSlip,
    Multiselect,
    VueElementLoading

  },
  data: function () {
    return {
      createFtcRadShipment: false,
      isLoading: false,
      companyNamelist: [],
      tableColumn: ['Select all','AWB', 'MPS Co', 'Client Name', 'Consignee Name', 'Consignee Address','IS TDS Applicable?','Is IRN Generated', 'IRN Response', 'RAD Date','Payment Status','Digital Signature Done','Actions','Download Invoice'],
      tableItems: [],
      CashMemo: "",
      totalPage: 0,
      currentPage: 1,
      total: 0,
      totalCount: 0,
      perPage: 0,
      pageLimit:50,
      offset: 0,
      radToDate: "",
      radFromDate: "",
      parentObj: {},
      companyName: null,
      AWB: "",
      printAwb:[],
      defaulthubid : null,
      showPrintCashMemo:false,
      responsedata : "",
      responsedetails : false,
      selectedShipments : [],
      bulkAwbPrint : [],
      showUploadCashMemo : false,
      selectedFiles : [],
      digitalsignature : null,
      digitalSignatureOptions : [{id:1 ,label:'Yes'},{id:2 ,label:'No'}],
      HubList : [],
      desthub : null,
      selectAll : false,
      uplodedRecords : [],
      modalLoading : false,
      irngenerated : null,
      reportData : [],
      clientNameObj:{}
    }
  },
  computed: {
    maxFromDate() {
      // Calculate the max from date (Today)
      const today = new Date();
      return today.toISOString().split('T')[0];
    },
    minFromDate() {
      // Calculate the min from date (90 days less than the current date)
      const minFromDate = new Date();
      minFromDate.setDate(minFromDate.getDate() - 90);
      return minFromDate.toISOString().split('T')[0];
    },
    maxToDate() {
      // Calculate the max to date (1 month greater than the from date)
      if (this.radFromDate) {
        const maxToDate = new Date(this.radFromDate);
        maxToDate.setMonth(maxToDate.getMonth() + 1);
        return maxToDate.toISOString().split('T')[0];
      }
      return '';
    },
    minToDate() {
      // Minimum to date should be equal to the from date
      return this.radFromDate;
    }
  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    userdetail.rolename[0] == "Hub Executive"
    this.defaulthubid = userdetail.rolename[0] == "Hub Executive" ? userdetail.hubID[0] : null ;
    await this.getCompanyShortName()
    await Promise.all([
      this.GetFTCShipmentListing(),
      this.getHublist()
    ]);
  },
  methods: {
    async GetFTCShipmentListing(reportflag){
      try {
        this.isLoading = true;
        this.selectAll = false;
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit,
        }
        if(this.defaulthubid){
          inputPayload.hubid = this.defaulthubid;
        }
        if(this.AWB){
          inputPayload.awb = this.AWB;
        }
        if(this.companyName){
          inputPayload.clientbusinessaccountid = this.companyName.clientbusinessaccountid;
        }
        if(this.radFromDate){
          inputPayload.raddatefrom = this.radFromDate;
        }
        if(this.radToDate){
          inputPayload.raddateto = this.radToDate;
        }
        if(this.CashMemo) {
          inputPayload.cashmemogenerated = this.CashMemo == 'Yes' ? true : false;
        }
        if(this.desthub) {
          let destArr = []
          this.desthub.forEach(element => {
            destArr.push(element.value)
          });
          inputPayload.desthub = destArr
        }
        if(this.digitalsignature) {
          inputPayload.digitalsignature = this.digitalsignature.label == 'Yes' ? 1 : 0;
        }
        if(this.irngenerated) {
          inputPayload.irngenerated = this.irngenerated.label;
        }
        if (reportflag) {
          inputPayload.reportdownload = 1
        }
        let result = await TripServices.GetPaidFTCListing(inputPayload)
        if(result.data.code == 200){
          this.reportData = result.data.data.rows
          if (reportflag) {
            this.isLoading = false;
            return;
          }
          this.tableItems = []
          this.totalCount = result.data.data.count
          this.tableItems = result.data.data.rows.map((el)=>{
            // let clientobj  = this.companyNamelist.filter(obj => {return obj.clientbusinessaccountid == el.clientbusinessaccountid})
            // let companyName = clientobj.length > 0 ? clientobj[0].label : ''
            return {
              'id': el.id,
              "AWB": el.awb,
              "MPS Co": el.noofmps,
              "Client Name":  this.clientNameObj[el.clientbusinessaccountid],
              "Consignee Name": el.consigneename,
              "Consignee Address": el.consigneeaddress1,
              "RAD Date": moment(el.raddate).tz('Asia/Kolkata').format('DD-MM-YYYY hh:mm:ss'),
              "Is IRN Generated" : el.irn ? "Yes" : "No",
              'IRN Response' : el.irnresponse ? true : false,
              "Payment Status" : el.ftcpaymentstatus == 1 ? "Paid" : "Unpaid",
              'iscompletebooking' : true,
              // 'FTCRecordsTableFlag' : true,
              "Cash Memo Generate": el.iscashmemogenerated == 1 ? "Yes" : "No",
              "irnresponse" : el.irnresponse,
              "Digital Signature Done" : el.isdigitallysigned == 1 ? "Yes" : "No",
              "cashmemopdfurl" : el.cashmemopdfurl,
              "Download Invoice" : el.cashmemopdfurl ? true : false,
              "IS TDS Applicable?" : el.istdsapplicable == 1? "Yes" : "No",
              'Actions': 'click OnEvent',
            }
          })
          // this.reset()
        }else{
          this.totalCount = 0
          this.tableItems = [];
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    searchFTCListing(){
      this.currentPage = 1;
      this.offset = 0;
      this.GetFTCShipmentListing();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.GetFTCShipmentListing();
    },
    reset () {
      this.currentPage = 1;
      this.offset = 0;
      this.AWB = "";
      this.companyName = null;
      this.radFromDate = "";
      this.radToDate = "";
      this.CashMemo = "";
      this.digitalsignature = null;
      this.desthub = null;
      this.selectAll = false;
      this.selectedShipments = []
      this.irngenerated = null
      this.onPageChange(1)
      this.GetFTCShipmentListing()
    },
    async getCompanyShortName() {
      try {
        var CompanyShortList = [];
        let result = await TripServices.getActiveInactiveClientList()
        CompanyShortList = result.data.data;
        let tempObj = {};
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.companyNamelist.push({
            'id': CompanyShortList[i].ClientMasterID,
            'label': CompanyShortList[i].CompanyName  ,
            'CompanyName': CompanyShortList[i].ClientMasterID,
            'clientbusinessaccountid': CompanyShortList[i].ClientBusinessAccountId
          })
          tempObj[CompanyShortList[i].ClientBusinessAccountId] = CompanyShortList[i].CompanyName
        }
        this.clientNameObj = tempObj
        
      } catch (err) {
        console.log(err);
      }
    },
    callParent() {
      this.GetFTCShipmentListing();
      this.createFtcRadShipment = false;
    },
    showCreateFTCShipment() {
      this.createFtcRadShipment = true;
    },
    async getCustomTableEvent(id) {
       if(id.actionType == 'cashMemo' || id.actionType == "calculateFtc"){
         this.parentObj.AWB = id.id;
         this.parentObj.action = id.actionType;
         // this.createFtcRadShipment = true;
          this.clickPrintCashMemo();
       }else if(id.actionType == 'response'){
        let responsedata  = this.tableItems.filter(function(Items) {
          return Items.id == id.id;
        });
            this.responsedata = responsedata[0].irnresponse;
            this.responsedetails = true
       }else if (id.actionType == "select") {
        if (id.isChecked == 1){
          let objIndex = this.tableItems.findIndex((obj => obj.id == id.id));
          this.tableItems[objIndex].ischecked = 1;
          this.selectedShipments.push({id : id.id, awb : this.tableItems[objIndex].AWB })
        }else{
          let index = this.selectedShipments.findIndex(item => item.id === id.id);
          if (index !== -1) {
            this.selectedShipments.splice(index, 1);
          }       
         }
       }else if (id.actionType == "selectall") {
        if (id.isChecked == 1){
          this.selectAll = true;
          this.selectedShipments = this.tableItems.map(item => ({ awb: item.AWB, id: item.id }));
          this.tableItems.forEach(item => {
            item.ischecked = 1; 
          });
        }else{
         this.selectedShipments = []
         this.selectAll = false;
         this.tableItems.forEach(item => {
          item.ischecked = 0; 
          });
         }       
        }else if (id.actionType == "downloadinvoice"){
        let item = this.tableItems.find(item => item.id === id.id);
        let payload = {
          url : item.cashmemopdfurl
        }
        this.isLoading = true;
        let signedurl = await TripServices.gets3signedurl(payload)
        this.isLoading = false;
        if (signedurl.data.code == 200) {
          this.fileview(signedurl.data.data.filepath);
        }else{
          this.$alert("No Invoice Found","", "error");
        }
        }
    },
    async clickPrintCashMemo() {
      this.isLoading = true;
      await this.setMulipleAwbData(this.parentObj.AWB)
      this.showPrintCashMemo = true;
      this.isLoading = false;
    },
    async setMulipleAwbData(){
      this.printAwb=[]
        let data = await this.GetCashMemoData()
        if(data.data.code == 200){
        this.printAwb.push(data.data.data)
        }else{
          this.$alert(item.AWB + " - " + data.data.message,"", "error");
        }
    },
    async GetCashMemoData(){
      let payload = {
        // 'awb':"9418522190201"
        awb:this.parentObj.AWB,
      }
      let data = await TripServices.GetCashMemoData(payload)
      return data
    },
    async downloadBulkData(){
      try {
        this.isLoading = true
        let idArr = []
        for (const el of this.selectedShipments) {
          idArr.push(el.id)
         }
          let payload = {
            idArr : idArr
          } 
        let data =await  TripServices.GetBulkCashMemoData(payload)

        if (data.data.code == 200) {
          let pdfData = data.data.data
          await this.generateZip(pdfData);
        }else{
          this.$alert(data.data.message,"", "error");
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false;
      }
    },
    async printCashMemo(){
      try {
        if (this.printAwb.length < 1) {
          this.isLoading = false
          return
        }
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
               font-size:20%;
           }
           hr {
                margin-top: 1rem;
                margin-bottom: 1rem;
                border: 1;
                border-top: 1px solid #000;
            }
           table {
               border-collapse: collapse;
               margin-left:3px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          @media print {
          .pagebreak {
          page-break-after: always;
          }
          }
          `
          this.$nextTick(() => {
            d.print(document.getElementById('printCashMemoData'), cssText);
          })
    } catch (error) {
      this.isLoading=false
      }
    },

    async generateZip(buffer) {
      const zip = new JSZip();
      buffer.forEach((buffer, index) => {
        zip.file(`${buffer.awb}.pdf`, buffer.data.data);
      });



      // Generate a Blob object from the zip archive
      zip.generateAsync({ type: 'blob' }).then((blob) => {
        // Create a download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'files.zip');

        // Trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      });


    },
    handleFileUpload(event) {
      this.uplodedRecords = [];
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        this.selectedFiles.push(files[i]);
      }
    },
    removeFile(index) {
      this.selectedFiles.splice(index, 1);
    },
   async uploadFiles() {
    try {
      this.uplodedRecords = [];
      if (this.selectedFiles.length === 0) {
        alert("Please select at least one file to upload.");
        return;
      }
      const formData = new FormData();
      for (let i = 0; i < this.selectedFiles.length; i++) {
        formData.append("files[]", this.selectedFiles[i]);
      }
      this.modalLoading = true;
      let result = await TripServices.UploadSignedCashMemo(formData)
      console.log(result);
      this.modalLoading = false;
      if (result.data.code == 200) {
        this.selectedFiles = [];
        //add logic to show uploaded result
        this.uplodedRecords = result.data.data
      }else{
        this.selectedFiles = [];
        this.$alert(result.data.message,"", "error");
      }
    } catch (error) {
      this.isLoading = false
    }
    
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleDragEnter(event) {
      event.preventDefault();
      this.dragOver = true;
    },
    handleDragOver(event) {
      event.preventDefault();
    },
    handleDragLeave(event) {
      event.preventDefault();
      this.dragOver = false;
    },
    handleDrop(event) {
      event.preventDefault();
      this.dragOver = false;
      const files = event.dataTransfer.files;
      this.handleFileUpload(event);
    },
    fileview(index){
      var link = document.createElement('a');
      link.href = index;
      link.setAttribute('target','_blank');
      window.open(index, '_blank');
      link.remove();
      return true;
    },
    async getHublist() {
      try {
        let InputPayload = {};
        let result = await MasterService.GetHublist(InputPayload);
        let HubList = result.data.data.data;
        for (var i = 0; i < HubList.length; i++) {
          this.HubList.push({
            'value': HubList[i].HubID,
            'text': HubList[i].HubName
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    closeUploadCashMemo(){
      this.showUploadCashMemo = false;
      this.uplodedRecords = [];
    },
    resetFiles(){
      this.selectedFiles = []
    },
    async downloadReport(){
      await this.GetFTCShipmentListing('1')
      const mappedData = this.reportData.map((item, index) => {    
        // let clientobj  = this.companyNamelist.filter(obj => {return obj.clientbusinessaccountid == item.clientbusinessaccountid})
        // let companyName = clientobj.length > 0 ? clientobj[0].label : ''
        return{
        'S No': index + 1,
        'Waybill Number': item.awb,
        'MPS Count': item.noofmps,
        'Client Name': this.clientNameObj[item.clientbusinessaccountid] ,
        'Consignee Name': item.consigneename,
        'Consignee Address': item.consigneeaddress1,
        'Is TDS Applicable':item.istdsapplicable == 1? "Yes" : "No",
        'TAN': item.tan,
        'Is IRN Generated': item.irn ? "Yes" : "No",
        'RAD Date':  moment(item.raddate).tz('Asia/Kolkata').format('DD-MM-YYYY hh:mm:ss'),
        'FTC Collected Amount': item.ftctotalamt,
        'Payment Status': item.ftcpaymentstatus == 1 ? "Paid" : "Unpaid",
        'Digital Signature Done': item.isdigitallysigned == 1 ? "Yes" : "No"
        }
    });
    if (mappedData.length>0) {
          const data = XLSX.utils.json_to_sheet(mappedData);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data, 'data')
          XLSX.writeFile(wb,'PaidFTCReport.xlsx');
    }
    },
    openUploadCashMemo(){
      this.showUploadCashMemo = true
      this.$refs.fileInput.value=null;
    }
  },
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/FTCPaidCashMemo/FTCPaidCashMemo.component.js